import { render } from "./QuestionTypeSelection.vue?vue&type=template&id=9826a310&scoped=true"
import script from "./QuestionTypeSelection.vue?vue&type=script&lang=js"
export * from "./QuestionTypeSelection.vue?vue&type=script&lang=js"

import "./QuestionTypeSelection.vue?vue&type=style&index=0&id=9826a310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9826a310"]])

export default __exports__